<template>
  <div>
    <el-table :data="tzQclDownRecord" stripe border height="500" style="width: 100%;height:100%">
      <el-table-column prop="result" label="状态" min-width="30" />
      <el-table-column prop="completedCount" label="数量" min-width="30" />
      <el-table-column prop="ngReason" label="不良原因" min-width="40" />
    </el-table>
  </div>
</template>

<script>
export default {
  name: "BusTzQclDownMaterialRecord",
  props: {
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {
      tzQclDownRecord: []
    }
  },
  methods: {
    async getTzQclDownRecord() {
      let {data: res} = await this.$axios.post('bus/tz/getTzQclDownRecord', this.parentData.id);
      if (res.code !== 0) {
        this.$message.error(res.message)
      } else {
        this.tzQclDownRecord = res.data
      }
    }
  },
  created() {
    this.getTzQclDownRecord()
  }
}
</script>

<style scoped>

</style>